import functions from "./functions.js";
import inputPopover from "./input-popover.js";
import inputGuests from "./input-guests.js";

$(function () {

    const guestsGroup = $('.search-form').find('.input-guests-group');
    guestsGroup.addClass('p-3 pl-4 pr-4');

    $(document).on("click", ".form-group", function (e) {

        const isFormGroup = $(e.target)[0].classList.contains("form-group");

        let $formGroup = isFormGroup
          ? $(e.target)
          : $(e.target).parents(".form-group");
        let $elem = $formGroup.find(".form-control");

        $elem.focus() && $elem.hasClass("select2") && $elem.select2("open");
    });

    // subscribe
    const $subscribe = $('.form-subscribe');
    if ( $subscribe.length ) {
        $subscribe.on('submit', e => {
            e.preventDefault();
            $subscribe.find('button').prop('disabled', true).find('.spinner-border').removeClass('d-none');
            $subscribe.find('.response-output').addClass('d-none');

            $.post('/services/subscribe.php', { email: $subscribe[0].email.value, name: $subscribe[0].name.value, language: functions.getLang() }).then(response => {
                $subscribe.find('button').prop('disabled', false).find('.spinner-border').addClass('d-none');
                $subscribe.find('.response-output').html(response.message).removeClass('d-none');
            });
        });
    }

    // excursions travel periods on click open collapse and center
    $('#booking-accordion').on('shown.bs.collapse', e => {
        e.target.scrollIntoView({
            behaviour: "smooth",
            block: "center",
            inline: "center"
        });
    });

    inputGuests.apply();

    // excursions travel periods on click open collapse and center
    $('.booking-toggle').on('click', e => {
        const $elem = $('#booking-accordion ' + $(e.target).attr('href'));
        $elem.collapse('show');
    });

    // menu links active
    const path = location.pathname.replace(/\/$/, '');
    $('.nav-main [href], footer [href]').each((i, link) => {
        let href = link.getAttribute('href');
        if (href && href != '#') {
            href = href.split('?')[0].replace(/\/$/, '');
            if (path === href) {
                $(link).addClass('active').closest('.nav-item').addClass('active');
            }
        }
    });

    // global tooltip init
    //('[data-toggle="tooltip"]').tooltip();

    // mobile menu handling
    (() => {
        const $header = $('.main-header');
        const $dropdownLinks = $header.find('.main-menu .nav-item.dropdown .nav-link');
        const $collapser = $header.find('.navbar-collapse');

        $dropdownLinks.on('click', e => {
            if (document.documentElement.clientWidth >= 992) {
                return;
            }
            if (e.currentTarget.classList.contains('show-dropdown')) {
                e.currentTarget.classList.remove('show-dropdown');
            } else {
                $dropdownLinks.removeClass('show-dropdown');
                e.currentTarget.classList.add('show-dropdown');
            }
        });

        // ensure navbar toggler also open closes main-menu
        $collapser
            .on('show.bs.collapse', () => {
                document.body.classList.add('modal-transition');
                document.body.classList.add('modal-active');
            })
            .on('hide.bs.collapse', () => {
                $dropdownLinks.removeClass('show-dropdown');
                document.body.classList.remove('modal-active');
            })
            .on('hidden.bs.collapse', () => {
                document.body.classList.remove('modal-transition');
            });
    })();



    // const $sliderMainItemsBg = $sliderMain.find('.slide-bg');
    // const sliderAnim = (e, i) => {
    //     $sliderMainItemsBg.removeClass('active');
    //     $sliderMainItemsBg.eq(i || 0).addClass('active');
    // };

    const $sliderMainList = $("#slider-main-list");
    $sliderMainList.lightSlider({
        item: 4,
        // mode: 'fade',
        pager: false,
        slideMargin: 15,
        pauseOnHover: false,
        // loop: false needs to be set because slideMove doesnt work without it
        loop: true,
        auto: false,
        enableDrag: false,
        vertical: true,
        verticalHeight: 600,
        controls: false,
        // adaptiveHeight: true,
    });
    $sliderMainList.find('.slider-card[data-trigger-slide="1"].active').addClass('selected');


    // home slider init
    const $sliderMain = $("#slider-main");
    $sliderMain.lightSlider({
        item: 1,
        mode: 'fade',
        pager: true,
        controls: false,
        slideMargin: 0,
        pauseOnHover: false,
        loop: true,
        auto: false,
        enableDrag: false,
    });

    const $cardImgTopSlider2 = $('.card-img-top-slider2');
    $cardImgTopSlider2.lightSlider({
        item: 1,
        controls: true,
        mode: 'fade',
        slideMargin: 0,
        pauseOnHover: false,
        auto: false,
        enableDrag: false,
        pager: false,
        loop: true,
    });

    /*$('.details-itinerary-slider').lightSlider({
        
    });*/

    // after you click on a card, set the main slider to the same trip
    $sliderMainList.find('.slider-card').on('click', function (el) {
        let currDataTriggerSlide = $(el.currentTarget)[0].dataset.triggerSlide;
        $sliderMainList.find('.slider-card').removeClass('selected');

        $sliderMainList.goToSlide(+currDataTriggerSlide);
        $sliderMain.goToSlide(+currDataTriggerSlide);
        $sliderMainList.find('.active').addClass('selected');
    });

    $('.arrow-up').on('click', function () {
        $sliderMainList.find('.selected').removeClass('selected');
        if ($sliderMainList.getCurrentSlideCount() == 1) {
            $sliderMainList.goToSlide($sliderMainList.getTotalSlideCount());
        } else {
            $sliderMainList.goToPrevSlide();
        }
        $sliderMainList.find('.active').addClass('selected');
        $sliderMain.goToPrevSlide();
    });

    $('.arrow-down').on('click', function () {
        $sliderMainList.find('.selected').removeClass('selected');
        if ($sliderMainList.getCurrentSlideCount() == $sliderMainList.getTotalSlideCount()) {
            $sliderMainList.goToSlide(1);
        } else {
            $sliderMainList.goToNextSlide();
        }
        $sliderMainList.find('.active').addClass('selected');
        $sliderMain.goToNextSlide();
    });



    // const $upcomingSlider = $("#upcoming-slider");
    // $upcomingSlider.lightSlider({
    //     item: 3,
    //     pager: true,
    //     controls: false,
    //     slideMargin: 0,
    //     pauseOnHover: false,
    //     auto: false,
    //     enableDrag: false,
    //     slideMove: 3
    // });

    const $cardImgTopSlider = $('.card-img-top-slider');
    $cardImgTopSlider.lightSlider({
        item: 1,
        controls: true,
        slideMargin: 0,
        pauseOnHover: false,
        auto: false,
        enableDrag: false,
        pager: false
    });

    $('.details-header-slider').lightSlider({
        item: 1,
        slideMargin: 0,
        controls: true,
        mode: 'fade',
        loop: true,
        prevHtml: '<i class="las la-angle-left la-2x p-2 text-white bg-military rounded-circle"></i>',
        nextHtml: '<i class="las la-angle-right la-2x p-2 text-white bg-military rounded-circle"></i>',
    });

    $('.catalogue-featured-slider').lightSlider({
        item: 3,
        // mode: 'fade',
        pager: true,
        slideMargin: 15,
        pauseOnHover: false,
        // loop: false needs to be set because slideMove doesnt work without it
        loop: true,
        auto: false,
        enableDrag: false,
        controls: false,
        prevHtml: '<i class="las la-angle-left la-2x p-2 text-white bg-accent rounded-circle"></i>',
        nextHtml: '<i class="las la-angle-right la-2x p-2 text-white bg-accent rounded-circle"></i>',
    });

    // const $upcomingSlider2 = $("#upcoming-slider2");
    // $upcomingSlider2.lightSlider({
    //     item: 1,
    //     pager: true,
    //     controls: false,
    //     slideMargin: 10,
    //     pauseOnHover: false,
    //     auto: false,
    //     enableDrag: false,
    //     slideMove: 1
    // });



    /* gallery */
    const lg = {};
    window.showGallery = (index, id) => {
        index = +index || 0;
        if (lg[id]) {
            lg[id].index = index;
            lg[id].build(index);
        } else {
            lg[id] = $('#' + id).lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($('[data-images-' + id + ']').attr('data-images-' + id))
            }).data('lightGallery');
        }
    };
    $('[data-gallery-id]').on('click', function (e) {
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });
    $('.btn-slider-gallery').on('click', e => {
        $(e.currentTarget).parent().find('.lslide.active').click();
    });
    /* end gallery */

    // scroll to element handling
    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.target);
        // if ($('body.details')) {
        //     $this.parents('.details-navbar').find('.nav-item.active').removeClass('active');
        //     $this.closest('.nav-item').addClass('active');
        // }

        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });

    // global datepicker init with automatic "dateTo" set if provided
    let displayDate = new Date('2020-01-01');
    let now = new Date();
    if (now > displayDate) {
        displayDate = now;
    }

    $('.datepicker-range').each((i, elem) => {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        $datepicker.flatpickr({
            mode: "range",
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            minDate: minDate ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="la la-chevron-circle-left la-fw la-2x pr-2"></i>',
            nextArrow: '<i class="la la-chevron-circle-right la-fw la-2x pl-2"></i>',
            locale: {
                rangeSeparator: ' - '
            }
        });
        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    });

    $('.datepicker').each((i, elem) => {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        $datepicker.flatpickr({
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            minDate: minDate ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="fa fa-chevron-circle-left fa-fw fa-2x pr-2"></i>',
            nextArrow: '<i class="fa fa-chevron-circle-right fa-fw fa-2x pl-2"></i>',
            onChange(selectedDates, dateStr, instance) {
                const $first = $(instance.input);
                // prevent other logic if second datepicker is triggered by first
                if (instance._openByFirst) {
                    delete instance._openByFirst;
                    return;
                }
                if ($first.attr('data-firstDate')) {
                    const $second = $first.closest('.form-row').find('[data-secondDate]').closest('.datepicker');
                    if ($second.length) {
                        const firstDate = new Date(selectedDates[0]);
                        firstDate.setDate(firstDate.getDate() + 1);
                        const secondInstance = $second[0]._flatpickr;
                        // check if firstDate is invalid
                        if (firstDate.getTime() === firstDate.getTime()) {
                            secondInstance._openByFirst = true;
                            secondInstance.set('minDate', firstDate);
                            if (!secondInstance.selectedDates[0]) {
                                firstDate.setDate(firstDate.getDate() + 6);
                                secondInstance.setDate(firstDate);
                            }
                            secondInstance.open();
                            $(secondInstance.altInput).focus();
                        }
                        else if (secondInstance.selectedDates[0]) {
                            secondInstance.clear();
                        }
                    }
                }
                // check if second date is cleared
                else if ($first.attr('data-secondDate') && !selectedDates[0]) {
                    $first.closest('.form-row').find('[data-firstDate]').closest('.datepicker')[0]._flatpickr.clear();
                }
            },
            onOpen(selectedDates, dateStr, instance) {
                if (instance.input.getAttribute('data-secondDate')) {
                    const $first = $(instance.input).closest('.form-row').find('[data-firstDate]').closest('.datepicker');
                    if ($first.length) {
                        const firstInstance = $first[0]._flatpickr;
                        if (!firstInstance.input.value) {
                            instance.close();
                            firstInstance.open();
                            firstInstance.altInput.focus();
                            return;
                        }
                    }
                }
                !dateStr && instance.jumpToDate(minDate ? minDate : displayDate);
            }
        });
        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    });

    // select2 templates can be defined as data-template="destinations" ...
    const selectTemplates = {
        destinations: data => {
            if (!data.element) {
                return data.text;
            }
            const $element = $('<span>').addClass(data.element.className).text(data.text);
            let elemClass;
            switch ((data.id).split('/').length) {
                case 6: elemClass = 'pl-2 font-weight-bold'; break;
                case 7: elemClass = 'pl-4'; break;
                default: elemClass = 'h5'; break;
            }
            $element.addClass(elemClass);
            return $element;
        },
        accommodation: data => {
            if (!data.element) {
                return data.text;
            }
            const $element = $('<span>').addClass(data.element.className).text(data.text);
            let elemClass;
            switch ((data.id).split('/').length) {
                case 6: elemClass = 'pl-2 font-weight-bold'; break;
                case 7: elemClass = 'pl-4'; break;
                default: elemClass = 'h5'; break;
            }
            $element.addClass(elemClass);
            return $element;
        },
        detailsListPrices: data => {
            if (!data.element) {
                return data.text;
            }
            const $element = $('<span>').addClass(data.element.className).text(data.text);
            let elemClass;
            switch ((data.id + '').split('--').length) {
                case 1: elemClass = 'h5 font-weight-normal text-warning-dk'; break;
                default: elemClass = 'pl-3'; break;
            }
            $element.addClass(elemClass);
            return $element;
        },
        numberPersons: data => {
            if (!data.element) {
                return data.text;
            }
            const $element = $('<span>').addClass(data.element.className).text(data.text);
            let elemClass;
            switch ((data.id + '').split(':').length) {
                case 1: elemClass = 'text-primary-dk'; break;
                case 2: elemClass = 'h5 font-weight-normal text-warning-dk'; break;
                case 3: elemClass = 'pl-3 h6'; break;
                case 4: elemClass = 'pl-4'; break;
            }
            $element.addClass(elemClass);
            return $element;
        }
    };

    // global init select2
    // data-templates
    // data-data
    // data-allow-clear
    // data-nosearch
    // placeholder
    $.map($('.select2'), elem => {
        const $elem = $(elem);
        const config = { dropdownParent: $elem.parent(), language: functions.getLang() };
        config.allowClear = $elem.attr('data-allow-clear');

        // find select2 which has an attribute data-data
        const data = $elem.attr('data-data');
        if (data) {
            try {
                config.data = JSON.parse(data);
            } catch (e) { }
        }
        else if ($elem.attr('data-special')) {
            let newData = $('body').attr('data-select-' + $elem.attr('data-special'));
            config.data = JSON.parse(newData);
        }

        if ($elem.attr('data-template')) {
            config.templateResult = selectTemplates[$elem.attr('data-template')];
        }
        if ($elem.attr('data-template')) {
            config.templateSelection = selectTemplates[$elem.attr('data-template-selection')];
        }

        if ($elem.attr('data-nosearch') !== undefined) {
            config.minimumResultsForSearch = Infinity;
        }

        const placeholder = $elem.attr('placeholder');
        $elem.removeAttr('placeholder');
        config.placeholder = placeholder || ' ';

        $elem.select2(config)
            .on('select2:clear', () => {
                $elem[0].cleared = true;
            })
            .on('select2:opening', e => {
                if ($elem[0].cleared) {
                    e.preventDefault();
                    $elem[0].cleared = false;
                }
            });
    });

    // advanced form controls
    // input-popover
    $('body').on('click', '.dropdown-menu-popover', e => {
        e.stopPropagation();
    });
    inputPopover.apply();


    // button checkbox
    $('.btn-checkbox').on('click', e => {
        let input = $(e.target).prev()[0];
        input.checked = !input.checked;
    });

    $('#cookie-bar-accept').on('click', function (e) {
        functions.setCookie('cookie_usage', 'accepted');
        $("#cookie-bar").addClass('d-none');
    });


    $('.currency-change').on('click', function (e) {
        functions.setCookie('currencyIdTo', e.target.id);
        location.reload();
    });

    // fancy cards
    $('.cards-fancy').on('click', '.card', e => {
        e.preventDefault();
        $(e.currentTarget).addClass('active').siblings().removeClass('active');
    });
});

$(window).on('load', () => {

    // load slide images
    $('.slider li[data-style]').each((i, slide) => {
        slide.setAttribute('style', slide.getAttribute('data-style'));
    });

    // header off-screen
    // const header = $('.top-header')[0];

    const header = $('.navbar')[0];
    const navbar = $('.navbar')[0];
    const blogPost = $('body.single').length || $('body.page-type-blog-post').length;
    const detailsPage = $('body.page-type-details').length;
    // if body has a class blog-post, then we should remove bg-transparent and set bg-primary
    // we should not continue "adding" or "removing" bg-transparent, it is constant solid color
    /*if (blogPost) {
        header.classList.remove('bg-transparent');
        header.classList.add('bg-primary');
    }
    let scrolled = false;
    let lastScrollY = 0;
    const checkHeader = () => {
        if (window.scrollY > lastScrollY) {
            if (!detailsPage) {
                // header.classList.add('off-screen');
                header.classList.remove('off-screen');
            }
            if (!blogPost) {
                header.classList.remove('bg-transparent');
            }
            // header.classList.remove('modal-transition');
            // header.classList.remove('modal-active');
            // navbar.classList.remove('show');
            // $(navbar).find('.show-dropdown').removeClass('show-dropdown');
        } else {
            if (!detailsPage) {
                // header.classList.remove('off-screen');
                header.classList.add('off-screen');
            }
            if (!blogPost && window.scrollY <= 300) {
                header.classList.add('bg-transparent');
            }
        }
        lastScrollY = window.scrollY;
    }*/

    // show/hide button for scroll to top
    const $btnScrollTop = $('.btn-scroll-top');
    const checkScrollTop = () => {
        $btnScrollTop.toggleClass('show', window.scrollY > 200);
        $('.bg-blur').css('filter', 'blur(' + window.scrollY / 50 + 'px)');
    }
    checkScrollTop();

    let timer = 0;
    let timerBtn = 0;
    /*$(window).on('scroll', () => {
        if (!scrolled) { // annoying first scroll when page load already scrolled
            scrolled = true;
            return;
        } else {
            cancelAnimationFrame(timer);
            timer = requestAnimationFrame(checkHeader);
        }
        clearTimeout(timerBtn);
        timerBtn = setTimeout(checkScrollTop, 50);
    });*/

    $('.navbar-toggler').on('click', function () {
        if ($('.navbar-toggler[aria-expanded=true]').length > 0) {
            $('.navbar')[0].classList.remove('bg-primary');
            $('.navbar')[0].classList.add('bg-transparent');
        } else {
            $('.navbar')[0].classList.add('bg-primary');
            $('.navbar')[0].classList.remove('bg-transparent');
        }
    });
});